import React from "react";
import { Building2, Globe2, Landmark, Users2, Briefcase, TrendingUp } from "lucide-react";
import "./Partners.css";
import Footer from "./Footer";
import NavBar from "./NavBar"

const partnerTypes = [
  {
    icon: Building2,
    title: "Commercial Banks",
    description: "Leading financial institutions across Africa and globally",
  },
  {
    icon: Landmark,
    title: "Development Finance",
    description: "International development agencies and DFIs",
  },
  {
    icon: TrendingUp,
    title: "Investment Firms",
    description: "Private equity and venture capital partners",
  },
  {
    icon: Globe2,
    title: "Export Credit Agencies",
    description: "Government-backed export financing institutions",
  },
  {
    icon: Briefcase,
    title: "Corporate Investors",
    description: "Strategic corporate partners and family offices",
  },
  {
    icon: Users2,
    title: "Government Bodies",
    description: "Ministries, parastatals, and regulatory authorities",
  },
];

function Partners() {
  return (
    <section id="partners" >
      <div className="partners-section py-5">
        <NavBar />
        <div className="container text-center">
          <div className="section-header mb-5">
            <h2 className="fw-bold display-6">
              Strategic <span className="text-accent">Partners</span>
            </h2>
            <p className="text-muted mt-3">
              Our extensive network spans continents and sectors, connecting you with the right partners for success
            </p>
          </div>

          <div className="partners-grid">
            {partnerTypes.map((partner, index) => {
              const Icon = partner.icon;
              return (
                <div className="partner-card" key={index}>
                  <div className="stat-icon mb-3">
                    <Icon size={28} className="icon-accent" />
                  </div>
                  <h4 className="fw-bold mb-2">{partner.title}</h4>
                  <p className="text-muted">{partner.description}</p>
                </div>
              );
            })}
          </div>
        </div>
        <Footer />
      </div>
    </section>
  );
}

export default Partners;
